<template>
  <!-- 登录页 -->
  <div class="login-main">
    <header-general :isWhite="true" type="login" @changeLoginShow="changeLoginShow" @changeJoinShow="changeJoinShow" />
    <Banner @play="videoPlay"></Banner>
    <!--<Video />-->
    <video-play v-if="showVideo" :src="src" @close="showVideo = false"></video-play>
    <login-box v-show="isShow" @changeLoginShow="changeLoginShow" />
    <join-ent :visible="showJoinEnt" @changeJoinShow="changeJoinShow" @login="changeLoginShow" />
    <!-- <Banner></Banner> -->
    <!-- <login-box></login-box> -->
    <Content></Content>
    <!-- 右边栏 帮助文档-->
    <div class="help-doc">
      <div class="floating-entrance download">
        <i class="r2-icon-action_get_app"/>
        <span>下载</span>
        <div class="sub-div">
          <ul>
            <li>
              <a href="造价云.exe" download="造价云.exe" @click="sentLog(100101045)">
                <i class="r2-icon-windows"/>
                <span>Windows 版</span>
              </a>
            </li>
            <!--<li class="cursor-default">-->
              <!--<div>-->
                <!--<i class="r2-icon-ewm qr-code"/>-->
                <!--<span>APP扫码下载</span>-->
                <!--<div class="qr-code&#45;&#45;box">-->
                  <!--<div class="qr-code&#45;&#45;wrapper">-->
                    <!--<img height="126" :src="qrCodeSrc" alt="二维码">-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
      <div class="floating-entrance quick-start" @mouseenter="sentLog(100101039)">
        <i class="r2-icon-wendang"/>
        <span>快速入门</span>
        <div class="sub-div">
          <ul>
            <li>
              <a href="/doc/quick_guide_enterprise.html" target="_blank" @click="sentLog(100101040)">
                <span>如何登录企业空间</span>
              </a>
            </li>
            <li>
              <a href="/doc/account_rights_guide.html" target="_blank" @click="sentLog(100101049)">
                <span>企业账号特权</span>
              </a>
            </li>
            <li>
              <a href="/doc/quick_guide_product.html" target="_blank" @click="sentLog(100101041)">
                <span>产品入门指南</span>
              </a>
            </li>
            <li>
              <a href="/doc/quick_guide_loginP.html" target="_blank" @click="sentLog(100101042)">
                <span>登录常见问题</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="floating-entrance prod-activity" @mouseenter="sentLog(100101043)">
        <i class="r2-icon-new"/>
        <span>产品活动</span>
        <div class="sub-div">
          <ul>
            <li>
              <a href="/doc/operating_new.html" target="_blank" @click="sentLog(100101044)">
                <span>新版公告</span>
              </a>
            </li>
            <!-- <li>
              <router-link to="/production">
                <span>内容中心</span>
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <dialog-browser-recommend></dialog-browser-recommend>
    <footer-general class="text-align-center" type="blocked"/>
    <w-backtotop :visibility-height="100" iconName="w-icon-sanjiao-copy2" :custom-style="backToTopCustomStyle"
                 ref="backToTop"></w-backtotop>
    <!-- <upgrade-notice></upgrade-notice> -->
  </div>
</template>
<style lang="less" type="text/less">
  .login-main {
    h1, h2, h3, h4, h5, h6, p, address, ol, ul, dl {
      margin-bottom: 0;
    }

    width: 100%;
    min-width: 1280px;
    /*height: 100%;*/
    padding-top: 72px;

    .download-cont {
      text-align: center;
      margin: 0 auto;
      margin-top: 48px;
      position: fixed;
      width: 100%;
      bottom: 94px;

      ul {
        display: inline-block;

        li {
          float: left;
          height: 40px;
          line-height: 40px;
          width: auto;
          margin-right: 30px;

          &:last-child {
            margin-right: 0;
          }

          a {
            display: inline-block;
            position: relative;
            border-radius: 28px;
            background: rgba(0, 0, 0, 0.4);
            border-color: rgba(0, 0, 0, 0.4);
            text-align: center;
            width: 172px;

            i {
              display: inline-block;
              font-size: 32px;
              line-height: 40px;
              box-sizing: border-box;
              color: #FFF;
            }

            .qr-code--box {
              display: none;
              width: 188px;
              height: 152px;
              position: absolute;
              border-radius: 4px;
              left: 158px;
              bottom: 0px;
              box-sizing: border-box;
              padding-left: 24px;
              animation: dialog-fade-in-horizontal .3s;
              /* 去掉小箭头 2020-06-11 */
              /* .triangle{
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-left: 1px solid rgba(33,37,48,0.2);
                border-top: 1px solid rgba(33,37,48,0.2);
                transform: rotateZ(-45deg);
                position: absolute;
                left: 10px;
                top: 64px;
                z-index: 100;
              } */

              .qr-code--wrapper {
                width: 152px;
                height: 152px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.2);
                box-sizing: border-box;
                border-radius: 4px;
                padding: 16px;
                position: relative;

                img {
                  width: 100%;
                }
              }
            }

            &:hover {
              background: #FFF;

              i {
                /*color: rgb(32,121,250);*/
                color: rgba(33, 37, 48, 1);
              }

              span {
                color: rgba(33, 37, 48, 1);
              }

              .qr-code--box {
                display: block;
              }
            }

            span {
              display: inline-block;
              height: 22px;
              margin-left: 8px;
              font-size: 14px;
              font-weight: 400;
              color: #FFF;
              line-height: 22px;
            }
          }
        }

        & > li {
          a {
            i {
              display: inline-block;
              font-size: 28px;
              line-height: 40px;
              box-sizing: border-box;
              color: #FFF;
            }
          }

        }
      }
    }

    .help-doc {
      position: fixed;
      z-index: 9;
      right: 16px;
      /*top: 50%;*/
      /*transform: translate(0, -50%);*/
      bottom: 150px;

      .floating-entrance {
        width: 60px;
        height: 60px;
        padding: 8px 0 8px 0;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 3px 9px 0px rgba(33, 37, 48, 0.2);
        border-radius: 8px;
        position: relative;
        text-align: center;
        color: #FFF;

        & > span {
          height: 20px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(33, 37, 48, 0.8);
          line-height: 20px;
        }

        & > i {
          display: block;
          font-size: 24px;
          color: rgba(33, 37, 48, 0.8);
        }

        &:hover {
          cursor: pointer;
          background: #2079FA;
          & > span, & > i {
            color: #FFFFFF;
          }

          .sub-div {
            display: block;
          }
        }

        .sub-div {
          position: absolute;
          right: 60px;
          top: 0;
          padding-right: 8px;
          display: none;
          animation: dialog-fade-in-horizontal .3s;

          ul {
            padding-top: 6px;
            border-radius: 8px;
            padding-right: 8px;
            width: 144px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.2);

            li {
              /*height: 44px;*/
              font-size: 14px;
              font-weight: 400;
              line-height: 44px;
              text-align: left;
              padding-left: 16px;
              a {
                display: block;
              }

              i {
                vertical-align: top;
                color: rgba(33, 37, 48, 1);
              }

              span {
                padding: 4px;
                color: rgba(33, 37, 48, 1);
              }

              &:not(.cursor-default):hover {
                span, i {
                  color: #2079FA;
                }
              }
            }
          }
        }

      }

      .prod-activity, .quick-start {
        margin-top: 12px;
      }
    }
  }
</style>
<script>
import windowResizeMixin from '@/assets/mixins/window-resize'
import documentScrollMixin from '@/assets/mixins/document-scroll'
import HeaderGeneral from '_c/common/Header/HeaderGeneral'
import Banner from '_c/PageIndex/HomeBanner/Index'
import Content from '_c/PageIndex/Content/Index'
import Video from '_c/PageIndex/Video/Index'
import VideoPlay from '_c/PageIndex/VideoPlay/Index'
import LoginBox from '_c/PageIndex/Login/IndexNew'
import JoinEnt from '_c/PageIndex/JoinEnt/index'
import FooterGeneral from '_c/common/Footer/FooterGeneral'
import DialogBrowserRecommend from '_c/common/DialogBrowserRecommend'
import {getCookie} from '@/assets/utils/CommonUtil'
// import UpgradeNotice from '_c/PageIndex/UpgradeNotice/Index'

export default {
  name: 'IndexPage',
  components: {
    HeaderGeneral,
    Banner,
    Content,
    LoginBox,
    JoinEnt,
    FooterGeneral,
    Video,
    VideoPlay,
    DialogBrowserRecommend
    // UpgradeNotice
  },
  mixins: [windowResizeMixin, documentScrollMixin],
  data () {
    return {
      user: {},
      footerMarginTop: 50,
      scrollTop: 0,
      qrCodeSrc: require('assets/images/login/r2-qr-code.png'),
      isWhite: false, // 页头是白底的（非透明）
      isShow: false, // 是否显示登陆框
      showVideo: false,
      showJoinEnt: false, // 是否显示加入企业
      src: ''
    }
  },
  mounted () {
    let userInfo = getCookie('ZJYUSERINFO') || {}
    this.user = userInfo
    this.isShow = (this.$route.query.willLogin === 'true')
    this.initEvent()
    const query = this.$route.query
    if (query && query.source && +query.source === 1) {
      this.sentLog(100101026)
    }
  },
  methods: {
    // 1.0 初始化事件
    initEvent () {
      this.computeHeight()
      this.resizeHandle.resize(() => {
        this.computeHeight()
      })
      this.computeScrollTop()
      this.scrollHandle.scroll(() => {
        this.computeScrollTop()
      })
    },
    // 1.1 初始化 窗口大小监听
    computeHeight () {
      const windowHeight = document.body ? document.body.clientHeight : (document.documentElement ? document.documentElement.clientHeight : 0)
      if (windowHeight && windowHeight > 920) {
        this.footerMarginTop = windowHeight - 920 + 50
      } else {
        this.footerMarginTop = 50
      }
    },
    // 1.2 计算纵向滚动条位置
    computeScrollTop () {
      let scrollTop = 0
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop
      } else if (document.body) {
        scrollTop = document.body.scrollTop
      }
      this.scrollTop = scrollTop
    },
    changeLoginShow (show) {
      this.isShow = show
      show && this.$refs.backToTop.backToTop()
    },
    // 加入企业
    changeJoinShow (show) {
      this.showJoinEnt = show
      show && this.$refs.backToTop.backToTop()
    },
    videoPlay (src) {
      this.showVideo = true
      this.src = src
    }
  }
}
</script>
